import { GlAlert, GlLink, GlSprintf } from '@gitlab/ui';
import { first } from 'lodash-es';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { truncateSha } from '~/lib/utils/text_utility';
import { s__, n__ } from '~/locale';
import Tracking from '~/tracking';
import { packageTypeToTrackCategory } from '~/packages_and_registries/package_registry/utils';
import { HISTORY_PIPELINES_LIMIT } from '~/packages_and_registries/shared/constants';
import HistoryItem from '~/vue_shared/components/registry/history_item.vue';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import { GRAPHQL_PACKAGE_PIPELINES_PAGE_SIZE, FETCH_PACKAGE_PIPELINES_ERROR_MESSAGE, TRACKING_ACTION_CLICK_PIPELINE_LINK, TRACKING_ACTION_CLICK_COMMIT_LINK, TRACKING_LABEL_PACKAGE_HISTORY } from '../../constants';
import getPackagePipelinesQuery from '../../graphql/queries/get_package_pipelines.query.graphql';
import PackageHistoryLoader from './package_history_loader.vue';
export default {
    name: 'PackageHistory',
    i18n: {
        createdOn: s__('PackageRegistry|Version %{version} was first created %{datetime}'),
        createdByCommitText: s__('PackageRegistry|Created by commit %{link} on branch %{branch}'),
        createdByPipelineText: s__('PackageRegistry|Built by pipeline %{link} triggered %{datetime} by %{author}'),
        publishText: s__('PackageRegistry|Published to the %{project} package registry %{datetime}'),
        combinedUpdateText: s__('PackageRegistry|Package updated by commit %{link} on branch %{branch}, built by pipeline %{pipeline}, and published to the registry %{datetime}'),
        fetchPackagePipelinesErrorMessage: FETCH_PACKAGE_PIPELINES_ERROR_MESSAGE
    },
    components: {
        GlAlert,
        GlLink,
        GlSprintf,
        HistoryItem,
        PackageHistoryLoader,
        TimeAgoTooltip
    },
    mixins: [
        Tracking.mixin()
    ],
    TRACKING_ACTION_CLICK_PIPELINE_LINK,
    TRACKING_ACTION_CLICK_COMMIT_LINK,
    props: {
        packageEntity: {
            type: Object,
            required: true
        },
        projectName: {
            type: String,
            required: true
        }
    },
    apollo: {
        pipelines: {
            query: getPackagePipelinesQuery,
            variables () {
                return this.queryVariables;
            },
            update (data) {
                return data.package?.pipelines?.nodes || [];
            },
            error (error) {
                this.fetchPackagePipelinesError = true;
                Sentry.captureException(error);
            }
        }
    },
    data () {
        return {
            pipelines: [],
            fetchPackagePipelinesError: false
        };
    },
    computed: {
        firstPipeline () {
            return first(this.pipelines);
        },
        lastPipelines () {
            return this.pipelines.slice(1).slice(-HISTORY_PIPELINES_LIMIT);
        },
        showPipelinesInfo () {
            return Boolean(this.firstPipeline?.id);
        },
        archivedLines () {
            return Math.max(this.pipelines.length - HISTORY_PIPELINES_LIMIT - 1, 0);
        },
        archivedPipelineMessage () {
            return n__('PackageRegistry|Package has %{updatesCount} archived update', 'PackageRegistry|Package has %{updatesCount} archived updates', this.archivedLines);
        },
        isLoading () {
            return this.$apollo.queries.pipelines.loading;
        },
        queryVariables () {
            return {
                id: this.packageEntity.id,
                first: GRAPHQL_PACKAGE_PIPELINES_PAGE_SIZE
            };
        },
        // eslint-disable-next-line vue/no-unused-properties -- tracking() is required by Tracking mixin.
        tracking () {
            return {
                category: packageTypeToTrackCategory(this.packageType)
            };
        }
    },
    methods: {
        truncate (value) {
            return truncateSha(value);
        },
        convertToBaseId (value) {
            return getIdFromGraphQLId(value);
        },
        trackPipelineClick () {
            this.track(TRACKING_ACTION_CLICK_PIPELINE_LINK, {
                label: TRACKING_LABEL_PACKAGE_HISTORY
            });
        },
        trackCommitClick () {
            this.track(TRACKING_ACTION_CLICK_COMMIT_LINK, {
                label: TRACKING_LABEL_PACKAGE_HISTORY
            });
        }
    }
};
